interface IViews {
  /**
   * @default false
   */
  canCreate?: boolean | string[];
  /**
   * @default false
   */
  canDelete?: boolean;
  /**
   * @default false
   */
  canDetail?: boolean | string[];
  /**
   * @default true
   */
  canRead?: boolean | string[];
  /**
   * @default false
   */
  canUpdate?: boolean | string[];
}

function getColumns(value: boolean | string[], cols: string[]): string[] {
  if (value === false) {
    return [];
  }

  if (value instanceof Array) {
    return value.filter(_ => !!cols.find(c => c === _));
  } else {
    return cols;
  }
}

const DEFAULT = {
  canCreate: false,
  canDelete: false,
  canDetail: false,
  canRead: true,
  canUpdate: false
};

class Views {
  private columns: string[];
  protected canCreate: string[];
  protected canDelete: boolean;
  protected canDetail: string[];
  protected canRead: string[];
  protected canUpdate: string[];

  constructor(o: IViews, columns: string[]) {
    this.canCreate = getColumns(o.canCreate || DEFAULT.canCreate, columns);
    this.canDelete = o.canDelete || DEFAULT.canDelete;
    this.canDetail = getColumns(o.canDetail || DEFAULT.canDetail, columns);
    this.canRead = getColumns(o.canRead || DEFAULT.canRead, columns);
    this.canUpdate = getColumns(o.canUpdate || DEFAULT.canUpdate, columns);
    this.columns = columns;
  }

  /**
   * @alias clone (non static)
   * @returns A new instance of `View` with the same values
   */
  public static clone(o: Views): Views {
    return o.clone();
  }

  /**
   * @returns A new instance of `View` with the same values
   */
  public clone(): Views {
    return new Views(this.toObject(), this.columns);
  }

  public getCanCreate(): string[] {
    return this.canCreate;
  }

  public getCanDelete(): boolean {
    return this.canDelete;
  }

  public getCanDetail(): string[] {
    return this.canDetail;
  }

  public getCanRead(): string[] {
    return this.canRead;
  }

  public getCanUpdate(): string[] {
    return this.canUpdate;
  }

  /**
   * @returns The current *view* as plain object
   */
  public toObject(): IViews {
    return {
      canCreate: this.canCreate,
      canDelete: this.canDelete,
      canDetail: this.canDetail,
      canRead: this.canRead,
      canUpdate: this.canUpdate
    };
  }

  /**
   * @returns The current *view* as string
   */
  public toString(): string {
    return JSON.stringify(this.toObject());
  }
}

export { IViews, Views };
